import Vue from 'vue';
import VueRouter, { RouterOptions } from 'vue-router';
import { SwFtrWorldwideAttacksRoute } from '@/modules/sw-ftr-worldwide-attacks';
import { SwFtrCaptureLabsThreatMetricsRoute } from '@/modules/sw-ftr-capture-labs-threat-metrics';
import { SwFtrSecurityNewsRoute } from '@/modules/sw-ftr-secuirty-news';
import { SwFtrBillMeterRoute, getDefaultParams } from '@/modules/sw-ftr-bill-meter';
// import { SwResponsiveIconMenuRoute } from '@/modules/sw-responsive-icon-menu';
// import { SwResponsiveThreatMetricsRoute } from '@/modules/sw-responsive-threat-metrics';
import { SwFtrDefault } from '@/modules/sw-ftr-default-route';
// import { SwAppResponsive } from '@/core/sw-app-responsive';
// import { SwResponsiveSecurityNewsRoute } from '@/modules/sw-responsive-security-news';
// import { SwResponsiveWorldwideAttacksRoute } from '@/modules/sw-responsive-worldwide-attacks';
// import { SwResponsiveMalwareRoute } from '@/modules/sw-responsive-malware';

const globalDefaultRouteName: string = 'globalDefault';

Vue.use(VueRouter);

export default new VueRouter(<RouterOptions>{
  mode: 'history',
  routes: [
    {
      path: '/m/page/',
      component: SwFtrDefault,
      children: [
            { ...SwFtrWorldwideAttacksRoute },
            { ...SwFtrCaptureLabsThreatMetricsRoute },
            { ...SwFtrSecurityNewsRoute },
            { ...SwFtrBillMeterRoute, name: globalDefaultRouteName },
      ],
    },
    // {
    //   path: '/main/mobile',
    //   component: SwFtrDefault,
    //   children: [
    //     { ...SwResponsiveIconMenuRoute },
    //     { ...SwResponsiveThreatMetricsRoute },
    //     { ...SwResponsiveSecurityNewsRoute },
    //     { ...SwResponsiveWorldwideAttacksRoute },
    //     { ...SwResponsiveMalwareRoute },
    //   ],
    // },
    {
      /** for whatever unmatched routes */
      path: '/*',
      redirect: { name: globalDefaultRouteName, params: getDefaultParams() },
    },
  ],
});
